var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-img"},[_c('img',{attrs:{"width":(1106 / 100) * 30,"src":"https://oss.baiweicaijing.com/v3/uploads/images/2025/07/30/856990a3bed83140d9a0aebc3574ffb2b946e.jpg","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }